import script from "./RoomLightDeviceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomLightDeviceItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomLightDeviceItem.vue?vue&type=style&index=0&id=54bee04e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bee04e"]])

export default __exports__